export const environment = {
  production: false,
  envName: 'dev',
  apiBaseUrl: 'https://dev-api.example.com',
};
